var render = function render(){var _vm=this,_c=_vm._self._c;return _c('signature',_vm._b({on:{"signature":_vm.handleSignatureSave,"clear":_vm.handleSignatureClear}},'signature',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }